// keys.ts — RQ cache keys for the current-user suite. Private.

const CURRENT_USER_QUERY_KEY = {
  Root: 'current-user',
  Profile: 'profile',
} as const;

export const currentUserKeys = {
  all: [CURRENT_USER_QUERY_KEY.Root] as const,
  profile: () => [...currentUserKeys.all, CURRENT_USER_QUERY_KEY.Profile] as const,
};
